export class SortController {
  instruction: SortInstruction = null;

  applyRequest(request: SortRequest) {
    const expression = request?.column != null && request?.order != null
      ? request.column.split('?').join(request.order) : null;
    this.instruction = new SortInstruction(request, expression);
  }

  toggleOrder() {
    switch (this.instruction?.request?.order) {
      case SortOrder.Ascending: this.applyRequest(new SortRequest(this.instruction?.request?.column, SortOrder.Descending)); break;
      case SortOrder.Descending: this.applyRequest(new SortRequest(this.instruction?.request?.column, null)); break;
      default: this.applyRequest(new SortRequest(this.instruction?.request?.column, SortOrder.Ascending));
    }
  }

  toggleColumn(column: string) {
    if (this.instruction?.request?.column === column) this.toggleOrder();
    else this.applyRequest(new SortRequest(column, SortOrder.Ascending));
  }
}

export enum SortOrder {
  Ascending = 'ASC',
  Descending = 'DESC'
}

export class SortRequest {
  constructor(public readonly column: string, readonly order: SortOrder) { }
}

export class SortInstruction {
  constructor(public readonly request: SortRequest, readonly expression: string) { }
}
